<div class="rfe" [class.rce-section-invalid]="factorErrorCount > 0"
     [attr.data-rce-path]="factorPath">

  <!-- Factor header ─────────────────────────────────────────────── -->
  <div class="rfe-header">

    <mat-form-field *ngIf="factor.kind === 'PER_NUMERIC_PROPERTY'"
                    appearance="outline" class="rfe-property"
                    [class.rce-invalid]="fieldHasError('/property')"
                    [attr.data-rce-path]="factorPath + '/property'">
      <mat-label i18n="@@Numeric property">Numeric property</mat-label>
      <mat-select [value]="factor.property" [disabled]="readOnly"
                  (selectionChange)="setProperty($event.value)">
        <mat-option *ngFor="let p of numericProperties" [value]="p">{{p}}</mat-option>
      </mat-select>
    </mat-form-field>

    <span class="rfe-spacer"></span>

    <span class="rce-error-badge" *ngIf="factorErrorCount > 0"
          [matTooltip]="factorErrorCount + ' validation error(s) on this factor'">
      <mat-icon>error</mat-icon>{{factorErrorCount}}
    </span>

    <button mat-stroked-button color="warn" class="rfe-delete-factor"
            (click)="confirmDelete()" [disabled]="readOnly"
            i18n-aria-label="@@Delete factor" aria-label="Delete factor">
      <mat-icon>delete</mat-icon>
      <span i18n="@@Delete factor">Delete factor</span>
    </button>
  </div>

  <!-- Per-factor numeric controls ──────────────────────────────── -->
  <div class="rfe-controls">

    <mat-form-field *ngIf="(factor.groups || []).length === 0"
                    appearance="outline" class="rfe-base-amount"
                    [class.rce-invalid]="fieldHasError('/baseAmount')"
                    [attr.data-rce-path]="factorPath + '/baseAmount'">
      <mat-label i18n="@@Amount">Amount</mat-label>
      <input matInput type="text" inputmode="decimal"
             [value]="factor.baseAmount != null ? localizeNumber(factor.baseAmount) : localizeNumber(0)"
             [disabled]="readOnly"
             (change)="setBaseAmountStr($any($event.target).value)"/>
      <mat-hint i18n="@@Used when no groups are defined.">Used when no groups are defined.</mat-hint>
    </mat-form-field>

    <mat-form-field appearance="outline" class="rfe-per-item-min rfe-compact"
                    [class.rce-invalid]="fieldHasError('/perItemMinimum')"
                    [attr.data-rce-path]="factorPath + '/perItemMinimum'">
      <mat-label i18n="@@Per-factor minimum">Per-factor minimum</mat-label>
      <input matInput type="text" inputmode="decimal"
             [value]="factor.perItemMinimum != null ? localizeNumber(factor.perItemMinimum) : localizeNumber(0)"
             [disabled]="readOnly"
             (change)="setPerItemMinimumStr($any($event.target).value)"
             i18n-matTooltip="@@Floor for this factor before global minimums."
             matTooltip="Floor for this factor before global minimums."/>
    </mat-form-field>

    <mat-form-field *ngIf="factor.kind === 'PER_NUMERIC_PROPERTY'"
                    appearance="outline" class="rfe-sig-rounding rfe-compact"
                    [class.rce-invalid]="fieldHasError('/signatureRoundingMultiple')"
                    [attr.data-rce-path]="factorPath + '/signatureRoundingMultiple'">
      <mat-label i18n="@@Signature rounding multiple">Signature rounding multiple</mat-label>
      <input matInput type="text" inputmode="numeric"
             [value]="factor.signatureRoundingMultiple != null ? localizeNumber(factor.signatureRoundingMultiple) : localizeNumber(0)"
             [disabled]="readOnly"
             (change)="setSignatureRoundingStr($any($event.target).value)"
             i18n-matTooltip="@@Round the property up to a multiple before multiplying. Use 8 for page signatures."
             matTooltip="Round the property up to a multiple before multiplying. Use 8 for page signatures."/>
    </mat-form-field>

  </div>

  <!-- Groups ─────────────────────────────────────────────────────── -->
  <div class="rfe-groups">

    <app-rate-group-builder *ngFor="let g of (factor.groups || []); let i = index"
                            [group]="g"
                            [factorKind]="factor.kind"
                            [groupPath]="groupPath(i)"
                            [validation]="validation"
                            [scopeConfig]="scopeConfig"
                            [readOnly]="readOnly"
                            (groupChange)="onGroupChange(i, $event)"
                            (groupDelete)="onGroupDelete(i)">
    </app-rate-group-builder>

    <div class="rfe-add-group">
      <button mat-stroked-button (click)="addGroup()" [disabled]="readOnly"
              i18n-matTooltip="@@Add group tooltip"
              matTooltip="Add another group to this factor. Groups inside one factor share the same cost concept and their amounts are summed together — use a new group when the same charge needs to be split across two characteristic axes (e.g. one group keyed on binding, another on paper type). Use a new factor instead when the charge is an independent line item (e.g. setup vs. per-page printing).">
        <mat-icon>add_box</mat-icon>
        <span i18n="@@Add group">Add group</span>
      </button>
    </div>

  </div>

</div>



